// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2B1gu","footer":"ChangeClinic_footer__1fi-w"};